import { useEdgeFunction } from "./00_useEdgeFunction";
import { BlockResponse } from "../types";

// 03_block - matches GraphQL BLOCK_SEARCH_TEXT query
export const useBlock = (block_id?: string) => {
  const input = block_id ? { block_id } : undefined;
  const { data, loading, error, execute, reset } = useEdgeFunction<BlockResponse>(
    "block",
    input
  );

  // Manual execution method
  const getBlock = (block_id: string) => execute({ block_id });

  return { data, loading, error, getBlock, reset };
};
